import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="policy-page container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: [Date]</p>

      <h2>1. Introduction</h2>
      <p>At FB PROTECH WEB EXPERT, we respect your privacy and are committed to protecting your personal data.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name, email, and phone number</li>
        <li>Business name, address, and payment information</li>
        <li>Tracking data from pixels or cookies (if integrated)</li>
      </ul>

      <h2>2. How We Use It</h2>
      <ul>
        <li>To provide services and support</li>
        <li>To send invoices or order confirmations</li>
        <li>For marketing (only with your consent)</li>
        <li>To improve our website performance and customer experience</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do not sell your personal data. We may share it with:</p>
      <ul>
        <li>Payment processors (e.g., Stripe)</li>
        <li>Service providers under strict confidentiality</li>
        <li>Authorities if legally required</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We use SSL encryption and secure hosting to protect your data. However, no internet method is 100% secure.</p>

      <h2>5. Your Rights</h2>
      <p>You may request access, correction, or deletion of your data by emailing protechwebexpert@gmail.com</p>

      <h2>6. Cookies</h2>
      <p>We may use cookies to improve site performance and marketing attribution. You can control cookies in your browser settings.</p>

      <h2>7. Contact</h2>
      <p>For privacy questions, email us at protechwebexpert@gmail.com</p>
    </div>
  );
};

export default PrivacyPolicyPage; 